import { verticalCommonStyles } from './verticalCommon';
export const verticalIconCommonStyles = (FOUNDATIONS, FONT) => ({
    ...verticalCommonStyles(FOUNDATIONS, FONT),
    container: {
        ...verticalCommonStyles(FOUNDATIONS, FONT).container,
        display: 'flex',
        flex_direction: 'column',
        padding: FOUNDATIONS.spacing_250,
    },
});
//# sourceMappingURL=verticalIconCommon.js.map